<template>
    <div class="white-bg list-item">

        <strong>{{dataInfo.name}}</strong>

        <div class="value">{{dataInfo.phone}}</div>

    </div>
</template>

<script>
    export default {
        name: "ListItem1",

        props: {
            dataInfo: {}
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    .list-item {
        border-radius: 10px;
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        strong {
            min-width: 80px;
            color: $fontColor-3;
            font-size: 20px;
        }
    }

</style>
